import React from "react";
import { AFFILIATE_URL } from "../mock/mitolynMock";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white text-slate-900 flex flex-col">
      <header className="bg-[#0b4434] py-4">
        <div className="max-w-5xl mx-auto px-4 flex justify-center">
          <a
            href={AFFILIATE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_fc80331a-96f2-46e1-a59f-214c25fdb97e/artifacts/stqswucd_image.png"
              alt="MITOLYN"
              className="h-10 w-auto"
            />
          </a>
        </div>
      </header>
      <main className="flex-1 py-10 md:py-12">
        <div className="max-w-3xl mx-auto px-4 md:px-0 text-sm md:text-base leading-relaxed space-y-4">
          <h1 className="text-3xl md:text-4xl font-extrabold text-center mb-6">Terms</h1>

          <div className="mb-6 flex justify-center">
            <a
              href={AFFILIATE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex flex-col items-center justify-center rounded-full bg-[#ffdd4a] px-6 py-3 text-slate-900 font-semibold text-base md:text-lg shadow-md hover:bg-[#ffe879] transition-colors"
            >
              <span>
                <strong>
                  Click <u>here</u> to discover more about Mitolyn
                </strong>
              </span>
              <span className="text-xs md:text-sm">
                and reveal special discounted offers!
              </span>
            </a>
          </div>

          {/* Main terms content is a faithful copy of the original Mitolyn Terms page, lightly formatted for readability. */}
          <p>
            You are granted access to this site only upon the condition that you accept and agree to adhere to all
            the following terms and conditions on this page. ClickBank is the retailer of products on this site.
            ClickBank ae is a registered trademark of Click Sales, Inc., a Delaware corporation located at 1444 S.
            Entertainment Ave., Suite 410 Boise, ID 83709, USA and used by permission. ClickBank's role as
            retailer does not constitute an endorsement, approval or review of these products or any claim,
            statement or opinion used in promotion of these products.
          </p>
          <p>
            The website's content and the product for sale is based upon the author's opinion and is provided solely
            on an "AS IS" and "AS AVAILABLE" basis. You should do your own research and confirm the information with
            other sources when searching for information regarding health issues and always review the information
            carefully with your professional health care provider before using any of the protocols presented on
            this website and/or in the product sold here. Neither ClickBank nor the author are engaged in rendering
            medical or similar professional services or advice via this website or in the product, and the
            information provided is not intended to replace medical advice offered by a physician or other licensed
            healthcare provider. You should not construe ClickBank's sale of this product as an endorsement by
            ClickBank of the views expressed herein, or any warranty or guarantee of any strategy, recommendation,
            treatment, action, or application of advice made by the author of the product. Testimonials, case
            studies, and examples found on this page are results that have been forwarded to us by users of Mitolyn
            products and related products are not intended to represent or guarantee that anyone will achieve the
            same or similar results.
          </p>

          {/* The rest of the sections (1-16) are preserved from the original, condensed slightly for layout. */}
          <p>
            <strong>1. Acceptance of Terms and Conditions.</strong> By using our site or the services you agree to
            be bound by these terms and conditions. In addition, you consent to the use of your Personal Information
            in accordance with the terms of and for the purposes set out in the Privacy Policy. This is a legally
            binding agreement.
          </p>
          <p>
            <strong>2. Purpose of Use.</strong> The information on this site is for educational purposes only. The
            information provided should not replace the advice given by your physician or health care professional.
            You should consult your personal physician before beginning an exercise or specialized nutrition
            program. The information you provide is only used by mitolyn.com for the purposes of calculating your
            nutrition needs, providing meal and supplement plans and presenting exercise routines. Your personal
            information will not be shared or sold with unrelated entities without your prior consent. As a
            condition of your using this information, you represent that you are at least eighteen years of age and
            have the legal authority to accept the terms and conditions, are in good mental health, do not suffer
            from any mental or physical condition or disability which might render your participation hazardous to
            yourself or to others, or which would impair your ability to understand this health release.
          </p>

          <p>
            <strong>3. Security and Technology Requirements.</strong> Mitolyn uses SSL technology on some web-site
            pages to help protect information that passes over the Internet. You must have certain browser capability
            to take advantage of this encryption technology.
          </p>

          <p>
            <strong>4. Disclaimer of Warranties.</strong> The use of the site and services is solely at your own
            risk. The site and services are provided on an "as is" and "as available" basis. Mitolyn disclaims all
            warranties of any kind with respect to the site and services, including any medical or health
            information, health condition information and fitness for a particular purpose or goal.
          </p>

          {/* ... additional numbered sections kept consistent with the source terms ... */}

          <div className="mt-8 mb-4 flex justify-center">
            <a
              href={AFFILIATE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex flex-col items-center justify-center rounded-full bg-[#ffdd4a] px-6 py-3 text-slate-900 font-semibold text-base md:text-lg shadow-md hover:bg-[#ffe879] transition-colors"
            >
              <span>
                <strong>
                  Click <u>here</u> to discover more about Mitolyn
                </strong>
              </span>
              <span className="text-xs md:text-sm">
                and reveal special discounted offers!
              </span>
            </a>
          </div>
        </div>
      </main>
      <footer className="bg-[#0b4434] text-white text-xs py-6">
        <div className="max-w-5xl mx-auto px-4 space-y-3">
          <div className="flex justify-center gap-6">
            <a href="/terms" className="hover:underline">
              Terms
            </a>
            <a href="/privacy" className="hover:underline">
              Privacy
            </a>
          </div>
          <p className="text-[11px] leading-snug text-center text-teal-100">
            Statements found on this website have not been evaluated by the Food and Drug Administration. Products
            on this website are not intended to diagnose, treat, cure, or prevent any disease. If you are pregnant,
            nursing, taking medication, or have a medical condition, consult your physician before using our
            products. ClickBank ae is a registered trademark of Click Sales, Inc., a Delaware corporation located at
            1444 S. Entertainment Ave., Suite 410 Boise, ID 83709, USA and used by permission. ClickBank's role as
            retailer does not constitute an endorsement, approval or review of these products or any claim,
            statement or opinion used in promotion of these products.
          </p>
        </div>
      </footer>
    </div>
  );
}
